import * as React from "react";

function SvgWarning(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 34 32" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.73.829L.258 29.107C-.417 30.344.31 32 1.529 32h30.942c1.22 0 1.947-1.656 1.27-2.893L18.271.83c-.605-1.105-1.937-1.105-2.542 0zM14 10h6l-1 12h-4l-1-12zm1 14v4h4v-4h-4z"
        fill="#956507"
      />
    </svg>
  );
}

export default SvgWarning;
